import {
	BranchSvg,
	CategorySvg,
	CompetitionSvg,
	IProjtechSidebarProps,
	JurySvg,
	QuestionBankSvg,
	UserSvg,
} from '@projtech-package/react-components/lib';
import { RoutesData } from './routes';

export const sidebarData: IProjtechSidebarProps[] = [
	{
		link: RoutesData.home.route,
		title: RoutesData.home.title,
		svg: () => BranchSvg(),
	},
	{
		link: 'RoutesData.home.route',
		title: RoutesData.home.title,
		svg: () => BranchSvg(),
	},
	{
		link: 'RoutesData.home.route1',
		title: RoutesData.home.title,
		svg: () => BranchSvg(),
	},
];
